/**
 * Иконки UI kit — пак Lucide (`lucide-react`).
 *
 * Здесь только сопоставление «наше семантическое имя -> иконка Lucide»,
 * поэтому смена пака или отдельной иконки — правка одной строки, а не поиск
 * по всем местам использования.
 *
 * Размер по умолчанию `1em`: иконка наследует кегль родителя, а конкретные
 * значения задаются спеками компонентов (`--button-icon-size`, `--field-icon-size`).
 */
import {
  Bot,
  BookOpen,
  Check,
  ChevronDown,
  ChevronRight,
  Copy,
  ExternalLink,
  House,
  Info,
  KeyRound,
  Layers,
  ListTree,
  Menu,
  Monitor,
  Moon,
  Play,
  Plug,
  Plus,
  RefreshCw,
  Route,
  Search,
  SlidersHorizontal,
  Sparkles,
  Sun,
  Trash2,
  Upload,
  Workflow,
  X,
  type LucideIcon,
  type LucideProps,
} from "lucide-react";

/** Обёртка, задающая размер по умолчанию и пробрасывающая остальные пропсы. */
const icon = (Component: LucideIcon) => {
  const Wrapped = ({ size = "1em", ...rest }: LucideProps) => <Component size={size} {...rest} />;
  Wrapped.displayName = `Icon(${Component.displayName ?? "lucide"})`;
  return Wrapped;
};

export const ChevronDownIcon = icon(ChevronDown);
export const ChevronRightIcon = icon(ChevronRight);
export const CheckIcon = icon(Check);
export const CloseIcon = icon(X);
/** Гамбургер: открывает боковое меню, когда оно свёрнуто в шторку. */
export const MenuIcon = icon(Menu);
export const CopyIcon = icon(Copy);
export const SearchIcon = icon(Search);
export const PlayIcon = icon(Play);
export const ExternalIcon = icon(ExternalLink);
export const RefreshIcon = icon(RefreshCw);
export const PlusIcon = icon(Plus);
export const TrashIcon = icon(Trash2);
export const InfoIcon = icon(Info);
// `Home` в Lucide — устаревший алиас, актуальное имя иконки — `House`.
export const HomeIcon = icon(House);
export const DocsIcon = icon(BookOpen);
export const ModelsIcon = icon(Layers);
export const KeyIcon = icon(KeyRound);
export const PipelineIcon = icon(Workflow);
export const ParamsIcon = icon(SlidersHorizontal);
export const IntegrationIcon = icon(Plug);
export const FramesIcon = icon(Route);
export const ListIcon = icon(ListTree);
export const ThemeLightIcon = icon(Sun);
export const ThemeDarkIcon = icon(Moon);
export const ThemeSystemIcon = icon(Monitor);
export const UploadIcon = icon(Upload);
export const AgentIcon = icon(Bot);
export const SkillIcon = icon(Sparkles);
